import getLangLocale from 'I18n/utils/getLangLocale';
import computeTimezoneGroups from '../helpers/computeTimezoneGroups';
import TimezoneAliases from '../lists/TimezoneAliases';
var cachedTimezoneGroups;
var previousLocale;
export default (function () {
  var currentLocale = getLangLocale();

  if (currentLocale === previousLocale) {
    return cachedTimezoneGroups;
  } else {
    var timezoneAliases = TimezoneAliases();
    previousLocale = currentLocale;
    cachedTimezoneGroups = computeTimezoneGroups(timezoneAliases);
    return cachedTimezoneGroups;
  }
});